export const helpBootNotification = {
  chargeBoxSerialNumber: {
    type: 'String[25]',
    description: 'Optional. This contains a value that identifies the serial number of the Charge Box inside the Charge Point. Deprecated, will be removed in future version.'
  },

  chargePointModel: {
    type: 'String[20]',
    description: 'Required. This contains a value that identifies the model of the ChargePoint'
  },

  chargePointSerialNumber: {
    type: 'String[25]',
    description: 'Optional. This contains a value that identifies the serial number of the Charge Point.'
  },

  chargePointVendor: {
    type: 'String[20]',
    description: 'Required. This contains a value that identifies the vendor of the ChargePoint.'
  },

  firmwareVersion: {
    type: 'String[50]',
    description: 'Optional. This contains the firmware version of the Charge Point.'
  },

  iccid: {
    type: 'String[20]',
    description: 'Optional. This contains the ICCID ( Integrated Circuit Card Identification Number ) of the modem’s SIM card.'
  },

  imsi: {
    type: 'String[20]',
    description: 'Optional. This contains the IMSI ( International mobile subscriber identity ) of the modem’s SIM card.'
  },

  meterSerialNumber: {
    type: 'String[25]',
    description: 'Optional. This contains the serial number of the main power meter of the Charge Point.'
  },

  meterType: {
    type: 'String[25]',
    description: 'Optional. This contains the type of the main power meter of the Charge Point.'
  }
}


// Outcomes the firmware simulation can be forced to; Installed means the real result.
export const firmwareOutcomes = {
  Installed: 'Real result: download the firmware from the location, install it, reboot and report Installed (or DownloadFailed when the download fails).',
  DownloadFailed: 'Report DownloadFailed without downloading.',
  InvalidSignature: 'Download, then report InvalidSignature (signed firmware updates only: 1.6 SignedUpdateFirmware, 2.x UpdateFirmware with a signature).',
  InstallationFailed: 'Download, then report InstallationFailed instead of rebooting.',
}

export const simulateInfo = {
  diagnosticFileName: {
    description: 'Name of the diagnostics / log file the charge point uploads (returned in GetDiagnostics.conf fileName / GetLog filename). {id} is the Charge Point ID, {type} the log type (diagnostics, security, datacollector), {time} the UTC time.',
    valueDescription: ''
  },

  diagnosticUploadTime: {
    description: 'The file is really uploaded to the location of GetDiagnostics / GetLog (HTTP or HTTPS from the browser; FTP too in headless mode). This adds a wait before each upload attempt, e.g. to see Uploading in the CSMS.',
    valueDescription: 'Extra seconds before each upload attempt (0: upload right away)'
  },

  diagnosticStatus: {
    description: 'Outcome of an upload.',
    valueDescription: {
      Auto: 'Real result: Uploaded when the server accepts the file, otherwise UploadFailed (1.6 GetDiagnostics) or the reason (UploadFailure, PermissionDenied, BadMessage, NotSupportedOperation).',
      UploadFailed: 'Report a failed upload without contacting the server.',
    }
  },

  httpUploadMethod: {
    description: 'How a file goes to an http(s) location. Credentials in the URL (https://user:password@host/path) are sent as Basic Auth. From the browser the server must allow CORS.',
    valueDescription: {
      POST: 'POST multipart/form-data with the file in the field "file".',
      PUT: 'PUT the raw file; a location ending in "/" gets the file name appended.',
    }
  },

  firmWareStatus: {
    description: 'Outcome of a firmware update (UpdateFirmware / SignedUpdateFirmware). The firmware is really downloaded from the location; after installing, the charge point reboots and reports the version found in the file name (e.g. evsafe-fw-2.3.1.bin -> 2.3.1) in its BootNotification.',
    valueDescription: { ...firmwareOutcomes }
  },

  connectorOneUnlock: {
    description: `What status return connector after Central System request unlock connector.`,
    valueDescription: {
      Unlocked: 'Connector has successfully been unlocked.',
      UnlockFailed: 'Failed to unlock the connector',
    }
  },

  connectorTwoUnlock: {
    description: `What status return connector after Central System request unlock connector.`,
    valueDescription: {
      Unlocked: 'Connector has successfully been unlocked.',
      UnlockFailed: 'Failed to unlock the connector',
    }
  },

  maxPowerW: {
    description: 'Maximum charging power of a connector (W), e.g. 3680 (16 A single-phase), 11000 (16 A three-phase), 22000 (32 A three-phase). Charging profiles and the power set on the connector lower it; the meter goes up by power x time.',
    valueDescription: ''
  },

  batteryCapacityWh: {
    description: 'Battery size of the simulated EV (Wh). The state of charge rises with the delivered energy; above 80 % the EV draws less power, at 100 % it stops (SuspendedEV).',
    valueDescription: ''
  },

  initialSoc: {
    description: 'State of charge (%) of an EV when it plugs in, i.e. at the start of each transaction.',
    valueDescription: ''
  },
}
